(function($){
 
 $('.product-single-slider').slick({
 	slidesToShow: 1,
  	slidesToScroll: 1,
  	arrows: false,
  	fade: false,
  	asNavFor: '.slidernav'

 });

 $('.product-single-slider-thumbnail').slick({
 	slidesToShow: 4,
  	slidesToScroll: 1,
  	arrows: false,
  	vertical: true,
  	infinite: false,
  	verticalSwiping: true,
  	focusOnSelect: true,
  	asNavFor: '.product-single-slider'
 });

 $('.image-thumb').slick({
 	slidesToShow: 10,
 	slidesToScroll: 1,
  	arrows: false,
  	infinite: false,
  	focusOnSelect: true,
  	asNavFor: '.product-single-slider'
 });
 $('.product-single-slider-thumbnail-mobile').slick({
  slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.slidernav'

 });
  
  $('.read-more-btn').click(function(){
  	$('.read-more-text').slideDown();
    $(this).fadeOut();
  });
  
})(jQuery);